import { render } from "./UserTagLabel.vue?vue&type=template&id=5f11823a"
import script from "./UserTagLabel.vue?vue&type=script&lang=js"
export * from "./UserTagLabel.vue?vue&type=script&lang=js"

import "./UserTagLabel.vue?vue&type=style&index=0&id=5f11823a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__